const SAVED_TYPE = {
    MOBILE: 'MOBILE',
    WEB: 'WEB',
    EXTENSION: 'EXTENSION',
    MOBILE_EXTENSION: 'MOBILE_EXTENSION'
}

export default SAVED_TYPE;
